import LabServiceModel from "@/models/LabServiceModel";

export default class AnalyteResultStatusModel extends LabServiceModel {
  modelName() {
    return 'analyte-result-status';
  }
  defaults() {
    return {
      id: null,
      status: null,
      description: null,
      order: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      analyte_result_status_logs: [],
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      status: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }
  icon() {
    return "shovel";
  }
  getVariant() {
    switch (this.status) {
      default:
        return 'dark';
    }
  }

}
